var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('label',[_vm._t("default")],2),_vm._v(" "),_c('b-form-textarea',_vm._b({class:_vm.addClass,attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-form-textarea',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df00f4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Textarea.vue
// module id = null
// module chunks = 